<div style="display: flex; align-items: center; justify-content: space-between; background-color: #c9511b; color: #fff; padding: 12px 14px;">
  <h3 style="margin: 0; font-size: 22px; font-weight: 700;">BEPS Categories</h3>
  <i class="fa fa-times" style="font-size: 20px; cursor: pointer;" (click)="cancel()"></i>
</div>

@if (isAddModal) {

  <form [formGroup]="categoriesForm" style="box-sizing: border-box; width: 100%; padding: 14px 18px 18px;">
    <div class="form-group" style="margin-bottom: 16px;">
      <label for="category" class="a-form-label">Category</label>
      <input type="text" class="form-control" style="box-sizing: border-box; width: 100%; display: block; height: 36px;" id="category" formControlName="category" required>
    </div>
    <div class="form-group" style="margin-bottom: 16px;">
      <label for="cbc_id" class="a-form-label">CBC ID</label>
      <input type="text" class="form-control" style="box-sizing: border-box; width: 100%; display: block; height: 36px;" id="cbc_id" formControlName="cbc_id" required>
    </div>
    <div style="display: flex; justify-content: flex-end; width: 100%; margin-top: 6px;">
      <ap-button [btnType]="'primary'" [label]="'Submit'" [disabled]="categoriesForm.invalid" (onClick)="onSubmit()"></ap-button>
    </div>
  </form>


} @else {


  <div style="padding: 20px 18px 16px;">
  <h4 class="a-h4" style="margin: 0 0 18px;">Are you sure you want to delete this category?</h4>

  <div style="display: flex; justify-content: flex-end; width: 100%;">
    <ap-button [btnType]="'primary'" [label]="'Yes'" class="ap-mr-spacing-3" (onClick)="delete()"></ap-button>
    <ap-button [label]="'No'" [btnType]="'secondary'" (onClick)="cancel()"></ap-button>
  </div>
  </div>

}

